"use client";

/**
 * Compatibility re-export — implementation lives in `clips/player/`.
 */

export {
  ClipVideoPlayer,
  type ClipVideoPlayerProps,
} from "../player/clip-video-player";
